import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { ITicket } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IChildTicketOptionProps {
  ticket: ITicket;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 400px;
  box-sizing: border-box;
  justify-content: space-between;
  background: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  position: relative;
  top: -10px;
  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  padding: 15px 7px;
  &:hover {
    background: ${withVar(DesignToken.SurfaceSecondaryHover)};
  }
`;

const Group = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${Text} {
    margin-right: 5px;
  }
`;

const mergedTicketIconStyles = css`
  display: flex;
  width: 20px;
  margin-right: 10px;
  filter: opacity(0.5);
  align-self: start;
`;

export const MergedTicketPreview: React.FC<IChildTicketOptionProps> = props => {
  const { ticket } = props;

  return (
    <Wrapper>
      <Group>
        <Icon
          name={ticket.parentTicket ? IconsEnum.ChildTicket : IconsEnum.ParentTicket}
          css={mergedTicketIconStyles}
          fill="none"
          width="20px"
          height="20px"
        />
        <Flex alignItems="flex-start">
          {ticket.parentTicket && (
            <>
              <Text fontWeight="600">Merged into:</Text>
              <Text>{ticket.parentTicket.shortID}</Text>
            </>
          )}
        </Flex>
        <Flex justifyContent="flex-start" alignItems="baseline" inline flexWrap>
          {ticket.childTickets.length > 0 && (
            <Text fontWeight="600" inline>
              Merged with sub tickets ({ticket.childTickets.length}):
            </Text>
          )}
          {ticket.childTickets.length > 0 &&
            ticket.childTickets.map((item, idx) => (
              <Text key={item.shortID}>
                {item.shortID}
                {idx + 1 !== ticket.childTickets.length && ","}
              </Text>
            ))}
        </Flex>
      </Group>
    </Wrapper>
  );
};
